import { render, staticRenderFns } from "./simulation-badge.vue?vue&type=template&id=99d42ac8&scoped=true&"
import script from "./simulation-badge.vue?vue&type=script&lang=ts&"
export * from "./simulation-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d42ac8",
  null
  
)

export default component.exports